import { render, staticRenderFns } from "./ProductosMain.vue?vue&type=template&id=535a17d8&scoped=true&"
import script from "./ProductosMain.vue?vue&type=script&lang=js&"
export * from "./ProductosMain.vue?vue&type=script&lang=js&"
import style0 from "./ProductosMain.vue?vue&type=style&index=0&id=535a17d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535a17d8",
  null
  
)

export default component.exports